import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { SpinnerWrapper, Spinner, Bar, SpinnerText } from './LoadingSpinner.styles';

interface LoadingSpinnerProps {
  text?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ text }) => {
  const bars = [
    {
      rotate: '0deg',
      delay: '0s',
    },
    {
      rotate: '30deg',
      delay: '-0.9167s',
    },
    {
      rotate: '60deg',
      delay: '-0.833s',
    },
    {
      rotate: '90deg',
      delay: '-0.7497s',
    },
    {
      rotate: '120deg',
      delay: '-0.667s',
    },
    {
      rotate: '150deg',
      delay: '-0.5837s',
    },
    {
      rotate: '180deg',
      delay: '-0.5s',
    },
    {
      rotate: '210deg',
      delay: '-0.4167s',
    },
    {
      rotate: '240deg',
      delay: '-0.333s',
    },
    {
      rotate: '270deg',
      delay: '-0.2497s',
    },
    {
      rotate: '300deg',
      delay: '-0.167s',
    },
    {
      rotate: '330deg',
      delay: '-0.0833s',
    },
  ];
  return (
    <SpinnerWrapper flexDirection="column" alignItems="center" justifyContent="center">
      <Spinner className="spinner">
        {bars.map((bar, index) => (
          <Bar key={`spinner-bar-${index}`} rotate={bar.rotate} delay={bar.delay} />
        ))}
      </Spinner>
      {text && (
        <SpinnerText color="black" variant="dek20" tagName="span" textAlign="center">
          {ReactHtmlParser(text)}
        </SpinnerText>
      )}
    </SpinnerWrapper>
  );
};
